import { baseFileName } from "./file-name-core.js";

export const PNG_PRESETS = Object.freeze({
  screen: Object.freeze({ dpi: 110 }),
  standard: Object.freeze({ dpi: 150 }),
  high: Object.freeze({ dpi: 220 })
});

export function pngPageName(fileName, pageNumber, pageCount) {
  if (pageCount === 1) return `${baseFileName(fileName)}.png`;
  const digits = Math.max(3, String(pageCount).length);
  return `${baseFileName(fileName)}-page-${String(pageNumber).padStart(digits, "0")}.png`;
}

export function pngZipName(fileName) {
  return `${baseFileName(fileName)}-png.zip`;
}
